define("settings/components/meta-marketing-api/insights-card", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="tAC--mmaCard qa--settings__metaMarketingApi__insightsCard" data-account-id={{@accountId}}>
    <div class="tAC--mmaCard__header">
      <span class="tAC--mmaCard__name">
        {{or @accountName (t "account.meta_marketing_api.playground.ad_accounts.unnamed")}}
      </span>
      <span class="tAC--mmaCard__id">{{this.displayAccountId}}</span>
    </div>
  
    <div class="tAC--mmaCard__grid">
      <div class="tAC--mmaCard__tile tAC--mmaCard__tile--gauge" style="--i:0">
        <svg aria-hidden="true" class="tAC--mmaCard__gauge" viewBox="0 0 80 80">
          <circle class="tAC--mmaCard__gauge-track" cx="40" cy="40" fill="none" r={{this.ringRadius}} stroke-width="8" />
          <circle
            class="tAC--mmaCard__gauge-fill"
            cx="40"
            cy="40"
            fill="none"
            r={{this.ringRadius}}
            stroke-dasharray={{this.ringCircumference}}
            stroke-dashoffset={{this.ctrRingDashOffset}}
            stroke-linecap="round"
            stroke-width="8"
            transform="rotate(-90 40 40)"
          />
        </svg>
        <div class="tAC--mmaCard__tile-content">
          <span class="tAC--mmaCard__tile-value">{{this.ctrDisplay}}</span>
          <span class="tAC--mmaCard__tile-label">
            {{t "account.meta_marketing_api.playground.ad_accounts.metrics.ctr"}}
          </span>
        </div>
      </div>
  
      <div class="tAC--mmaCard__tile tAC--mmaCard__tile--money tAC--mmaCard__tile--spend" style="--i:1">
        <div class="tAC--mmaCard__tile-content">
          <span class="tAC--mmaCard__tile-value">{{this.spendDisplay}}</span>
          <span class="tAC--mmaCard__tile-label">
            {{t "account.meta_marketing_api.playground.ad_accounts.metrics.spend"}}
          </span>
        </div>
      </div>
  
      <div class="tAC--mmaCard__tile tAC--mmaCard__tile--money tAC--mmaCard__tile--cpuc" style="--i:2">
        <div class="tAC--mmaCard__tile-content">
          <span class="tAC--mmaCard__tile-value">{{this.cpucDisplay}}</span>
          <span class="tAC--mmaCard__tile-label">
            {{t "account.meta_marketing_api.playground.ad_accounts.metrics.cost_per_unique_click"}}
          </span>
        </div>
      </div>
  
      <div class="tAC--mmaCard__tile tAC--mmaCard__tile--count tAC--mmaCard__tile--impressions" style="--i:3">
        <div class="tAC--mmaCard__tile-content">
          <span class="tAC--mmaCard__tile-value">{{this.impressionsDisplay}}</span>
          <span class="tAC--mmaCard__tile-label">
            {{t "account.meta_marketing_api.playground.ad_accounts.metrics.impressions"}}
          </span>
        </div>
      </div>
  
      <div class="tAC--mmaCard__tile tAC--mmaCard__tile--count tAC--mmaCard__tile--clicks" style="--i:4">
        <div class="tAC--mmaCard__tile-content">
          <span class="tAC--mmaCard__tile-value">{{this.clicksDisplay}}</span>
          <span class="tAC--mmaCard__tile-label">
            {{t "account.meta_marketing_api.playground.ad_accounts.metrics.clicks"}}
          </span>
        </div>
      </div>
  
      <div class="tAC--mmaCard__tile tAC--mmaCard__tile--count tAC--mmaCard__tile--actions" style="--i:5">
        <div class="tAC--mmaCard__tile-content">
          <span class="tAC--mmaCard__tile-value">{{this.totalActionsDisplay}}</span>
          <span class="tAC--mmaCard__tile-label">
            {{t "account.meta_marketing_api.playground.ad_accounts.metrics.total_actions"}}
          </span>
        </div>
      </div>
    </div>
  </div>
  */
  {
    "id": "m+qEsnts",
    "block": "[[[10,0],[14,0,\"tAC--mmaCard qa--settings__metaMarketingApi__insightsCard\"],[15,\"data-account-id\",[30,1]],[12],[1,\"\\n  \"],[10,0],[14,0,\"tAC--mmaCard__header\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"tAC--mmaCard__name\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[[30,2],[28,[37,1],[\"account.meta_marketing_api.playground.ad_accounts.unnamed\"],null]],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[14,0,\"tAC--mmaCard__id\"],[12],[1,[30,0,[\"displayAccountId\"]]],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"tAC--mmaCard__grid\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"tAC--mmaCard__tile tAC--mmaCard__tile--gauge\"],[14,5,\"--i:0\"],[12],[1,\"\\n      \"],[10,\"svg\"],[14,\"aria-hidden\",\"true\"],[14,0,\"tAC--mmaCard__gauge\"],[14,\"viewBox\",\"0 0 80 80\"],[12],[1,\"\\n        \"],[10,\"circle\"],[14,0,\"tAC--mmaCard__gauge-track\"],[14,\"cx\",\"40\"],[14,\"cy\",\"40\"],[14,\"fill\",\"none\"],[15,\"r\",[30,0,[\"ringRadius\"]]],[14,\"stroke-width\",\"8\"],[12],[13],[1,\"\\n        \"],[10,\"circle\"],[14,0,\"tAC--mmaCard__gauge-fill\"],[14,\"cx\",\"40\"],[14,\"cy\",\"40\"],[14,\"fill\",\"none\"],[15,\"r\",[30,0,[\"ringRadius\"]]],[15,\"stroke-dasharray\",[30,0,[\"ringCircumference\"]]],[15,\"stroke-dashoffset\",[30,0,[\"ctrRingDashOffset\"]]],[14,\"stroke-linecap\",\"round\"],[14,\"stroke-width\",\"8\"],[14,\"transform\",\"rotate(-90 40 40)\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tAC--mmaCard__tile-content\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaCard__tile-value\"],[12],[1,[30,0,[\"ctrDisplay\"]]],[13],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaCard__tile-label\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.meta_marketing_api.playground.ad_accounts.metrics.ctr\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"tAC--mmaCard__tile tAC--mmaCard__tile--money tAC--mmaCard__tile--spend\"],[14,5,\"--i:1\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tAC--mmaCard__tile-content\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaCard__tile-value\"],[12],[1,[30,0,[\"spendDisplay\"]]],[13],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaCard__tile-label\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.meta_marketing_api.playground.ad_accounts.metrics.spend\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"tAC--mmaCard__tile tAC--mmaCard__tile--money tAC--mmaCard__tile--cpuc\"],[14,5,\"--i:2\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tAC--mmaCard__tile-content\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaCard__tile-value\"],[12],[1,[30,0,[\"cpucDisplay\"]]],[13],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaCard__tile-label\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.meta_marketing_api.playground.ad_accounts.metrics.cost_per_unique_click\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"tAC--mmaCard__tile tAC--mmaCard__tile--count tAC--mmaCard__tile--impressions\"],[14,5,\"--i:3\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tAC--mmaCard__tile-content\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaCard__tile-value\"],[12],[1,[30,0,[\"impressionsDisplay\"]]],[13],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaCard__tile-label\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.meta_marketing_api.playground.ad_accounts.metrics.impressions\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"tAC--mmaCard__tile tAC--mmaCard__tile--count tAC--mmaCard__tile--clicks\"],[14,5,\"--i:4\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tAC--mmaCard__tile-content\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaCard__tile-value\"],[12],[1,[30,0,[\"clicksDisplay\"]]],[13],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaCard__tile-label\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.meta_marketing_api.playground.ad_accounts.metrics.clicks\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"tAC--mmaCard__tile tAC--mmaCard__tile--count tAC--mmaCard__tile--actions\"],[14,5,\"--i:5\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tAC--mmaCard__tile-content\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaCard__tile-value\"],[12],[1,[30,0,[\"totalActionsDisplay\"]]],[13],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaCard__tile-label\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.meta_marketing_api.playground.ad_accounts.metrics.total_actions\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@accountId\",\"@accountName\"],false,[\"or\",\"t\"]]",
    "moduleName": "settings/components/meta-marketing-api/insights-card.hbs",
    "isStrictMode": false
  });
  // Max CTR % to fill the ring. Real-world CTRs above ~10% are rare; capping keeps
  // the visual readable when a low-volume account has an outlier rate.
  const CTR_GAUGE_MAX = 10;
  const RING_RADIUS = 32;
  const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;
  function toNumber(value) {
    if (value === undefined || value === null || value === '') return undefined;
    const n = Number.parseFloat(value);
    return Number.isFinite(n) ? n : undefined;
  }
  class InsightsCardComponent extends _component2.default {
    get ctrValue() {
      return toNumber(this.args.metrics.ctr);
    }
    get ctrDisplay() {
      const v = this.ctrValue;
      if (v === undefined) return '—';
      return `${v.toFixed(2)}%`;
    }
    get ctrRingDashOffset() {
      const v = this.ctrValue ?? 0;
      const ratio = Math.min(v / CTR_GAUGE_MAX, 1);
      return RING_CIRCUMFERENCE * (1 - ratio);
    }
    get ringCircumference() {
      return RING_CIRCUMFERENCE;
    }
    get ringRadius() {
      return RING_RADIUS;
    }
    get spendDisplay() {
      return formatCurrency(toNumber(this.args.metrics.spend));
    }
    get cpucDisplay() {
      return formatCurrency(toNumber(this.args.metrics.cost_per_unique_click), {
        fractionDigits: 2
      });
    }
    get impressionsDisplay() {
      return formatCount(toNumber(this.args.metrics.impressions));
    }
    get clicksDisplay() {
      return formatCount(toNumber(this.args.metrics.clicks));
    }
    get totalActionsDisplay() {
      return formatCount(toNumber(this.args.metrics.total_actions));
    }
    get displayAccountId() {
      return this.args.accountId.startsWith('act_') ? this.args.accountId : `act_${this.args.accountId}`;
    }
  }
  _exports.default = InsightsCardComponent;
  function formatCurrency(n) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (n === undefined) return '—';
    const fractionDigits = opts.fractionDigits ?? (n >= 1000 ? 0 : 2);
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      }).format(n);
    } catch {
      return `$${n.toFixed(fractionDigits)}`;
    }
  }
  function formatCount(n) {
    if (n === undefined) return '—';
    try {
      return new Intl.NumberFormat(undefined, {
        maximumFractionDigits: 0
      }).format(n);
    } catch {
      return String(Math.round(n));
    }
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, InsightsCardComponent);
});